import React from 'react';
import classNames from 'classnames';
import { SECTION_BLOG_PAGE } from '@wix/communities-blog-client-common';
import Link from '../../../common/components/link/internal-link';
import styles from './link-list.scss';

type LinkListProps = {
  links?: {
    key: string;
    path: string;
    text: React.JSX.Element;
  }[];
  emptyState?: { text: string };
  sectionId?: string;
};

const LinkList: React.FC<LinkListProps> = ({
  links = [],
  emptyState = { text: '' },
  sectionId = SECTION_BLOG_PAGE,
}) => {
  return (
    <ul data-hook="link-list" className={styles.root}>
      {links.map(({ key, path, text }, i) => (
        <li
          data-hook="link-list-item"
          key={key}
          className={classNames(styles.item, {
            [styles.itemLast]: i === links.length - 1,
          })}
        >
          <Link to={path} sectionId={sectionId} addHoverClasses={false} className={styles.link}>
            <span className={styles.ellipsis}>{text}</span>
          </Link>
        </li>
      ))}

      {links.length === 1 && (
        <li data-hook="link-list-item" className={classNames(styles.itemEmptyMessage)}>
          <span className={styles.ellipsis}>{emptyState.text}</span>
        </li>
      )}
    </ul>
  );
};

export default LinkList;
